import React from 'react';
import { Instagram } from 'lucide-react';

// Bulle flottante Instagram (remplace l'ancien badge "Made with Emergent").
export default function FloatingInstagram() {
  return (
    <a
      href="https://www.instagram.com/hybrid_training.club/"
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Suivez Hybrid Training Club sur Instagram"
      title="@hybrid_training.club"
      className="fixed bottom-5 right-5 z-[60] w-14 h-14 rounded-full bg-accent text-[#0a0a0a] grid place-items-center shadow-lg shadow-black/40 ring-1 ring-black/10 hover:scale-110 active:scale-95 transition-transform duration-200"
    >
      <Instagram size={26} strokeWidth={2.2} />
    </a>
  );
}
